import React from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { useProfileScorecardById } from '../../hooks/useProfileScorecardById';
import PdfLearningTopics from '../../common/components/LearningTopics/PdfLearningTopics';
import { makeStyles } from '@material-ui/core/styles';
import { Typography, Box } from '@material-ui/core';




const useStyles = makeStyles((theme) => ({
  boxTitle: {
    marginTop:15,
    marginBottom:0
  },
  pscTitle: {
    fontSize: theme.typography.pxToRem(18),
    color: theme.palette.text.primary,
    fontWeight: theme.typography.fontWeightMedium,
    letterSpacing: '0.4px',
    marginBottom: 0,
    textAlign: 'center',
    textTransform: 'uppercase'
  }
}));

const PdfProfileScoreCard = props => {
    const classes = useStyles();
    const location = useLocation();
    const { id } = useParams();
    const {
      isFetching: isLoading,
      isError,
      error,
      data
    } = useProfileScorecardById(id);

  if (isLoading) return "loading...";
  if (isError) return `Error! ${error.message}`;
  const psc = data.profileScoreCard;

  return (
    <>
      <Box className={classes.boxTitle}>
        <Typography className={classes.pscTitle} variant="h1">
          Profile Scorecard: Digital Meta-Skills Dynamic Certification
        </Typography>
      </Box>
      <main>
        <PdfLearningTopics
          expirationDate={psc.expirationDate}
          serialNumber={psc.serialNumber}
          username={psc.username}
          badges={psc.badges}
          careerPaths={psc.careerPaths}
          urlPath={location.pathname}
          photo={psc.photo} />
      </main>
    </>
  );
}

export default PdfProfileScoreCard;
